module.exports = __webpack_public_path__ + "static/media/audio-05-tt.cd8695af.mp3";